import React, {useEffect} from "react";
import {BasicProps} from "../App";
import {checkToken} from "../support";
import {SSOButton} from "../Components/SSOButton";
import {Grid,} from "@mui/material";
import {SamaggiTypography} from "../Components/SamaggiTypography";
import SamaggiPaper from "../Components/SamaggiPaper";
import "@fontsource-variable/montserrat";


export const SignIn: React.FC<BasicProps> = (props) => {

    function init() {
        props.setShowCover(true);

        checkToken().then((res) => {
            if (res !== true) {
                props.setShowCover(false);
            }
        })
    }

    useEffect(() => {
        init();
    }, []);

    return (
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
            <SamaggiPaper noMargin maxWidth mobile={props.mobile} vertical={props.vertical} style={{marginTop: "auto", marginBottom: "auto"}}>
                <Grid container direction={"column"} spacing={4}>
                    <Grid item container direction={"column"} spacing={1}>
                        <Grid item>
                            <SamaggiTypography bold large center>Sign In to Continue</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center>Please sign in or create an account to access the store.</SamaggiTypography>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <SSOButton/>
                    </Grid>
                </Grid>
            </SamaggiPaper>
        </div>

    )

}
